import { render, staticRenderFns } from "./DeliveryTimeWidget.vue?vue&type=template&id=60a40b45&"
import script from "./DeliveryTimeWidget.vue?vue&type=script&lang=js&"
export * from "./DeliveryTimeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vasile_cyt/Documents/plentyDevTool/6501/19/DeliveryTimeWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a40b45')) {
      api.createRecord('60a40b45', component.options)
    } else {
      api.reload('60a40b45', component.options)
    }
    module.hot.accept("./DeliveryTimeWidget.vue?vue&type=template&id=60a40b45&", function () {
      api.rerender('60a40b45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/DeliveryTimeWidget.vue"
export default component.exports